<div class="">
  @if ((addresses$ | async).length && !(showAddAddressForm || showEditAddressForm)) {
    <div class="col-md-12 p-0 float-left">
      <button class="btn btn-block btn-outline-primary col-md-4 float-right" (click)="addAddressButtonHandle()">
        {{ 'knbrAddressBook.button.addAddress' | cxTranslate }}
      </button>
    </div>
    @if (!(addressesStateLoading$ | async)) {
      <div class="col-md-12 p-0 float-left mt-2">
        @for (address of addresses$ | async; track address) {
          <div class="col-md-4 p-1 float-left">
            <knbr-address-card
              [content]="getKnbrCardContent(address) | async"
              (editCard)="editAddressButtonHandle(address)"
              (setDefaultCard)="setAddressAsDefault(address.id)"
              (deleteCard)="setEdit(address.id)"
              [editMode]="address.id === editCard"
              (cancelCard)="cancelCard()"
            ></knbr-address-card>
          </div>
        }
      </div>
    } @else {
      <div class="col-md-12 cx-address-spinner">
        <cx-spinner></cx-spinner>
      </div>
    }
  }

  @if ((!(addressesStateLoading$ | async) && !(addresses$ | async).length) || showAddAddressForm) {
    <h3>{{ 'knbrAddressBook.heading.addAddress' | cxTranslate }}</h3>
    <knbr-address-form
      showTitleCode="true"
      [showCancelBtn]="!((addresses$ | async).length === 0)"
      actionBtnLabel="{{ 'knbrAddressBook.button.save' | cxTranslate }}"
      cancelBtnLabel="{{ 'knbrAddressBook.button.cancel' | cxTranslate }}"
      [setAsDefaultField]="!((addresses$ | async).length === 0)"
      (submitAddress)="addAddressSubmit($event)"
      (backToAddress)="addAddressCancel()"
      (cancelCard)="cancelCard()"
      >
    </knbr-address-form>
  }

  @if (showEditAddressForm) {
    <h3>{{ 'knbrAddressBook.heading.editAddress' | cxTranslate }}</h3>
    <knbr-address-form
      showTitleCode="true"
      actionBtnLabel="{{ 'knbrAddressBook.button.update' | cxTranslate }}"
      cancelBtnLabel="{{ 'knbrAddressBook.button.cancel' | cxTranslate }}"
      [addressData]="currentAddress"
      (submitAddress)="editAddressSubmit($event)"
      (backToAddress)="editAddressCancel()"
      >
    </knbr-address-form>
  }
</div>

